import ApiService from './api.service'

const ApplicationWindowService = {
  index (params = {}) {
    return ApiService.get('api/application-windows', { params })
  },

  validateStep1 (data) {
    return ApiService.postWithoutLoading('api/application-windows/validate/step1', data)
  },

  validateStep2 (data) {
    return ApiService.postWithoutLoading('api/application-windows/validate/step2', data)
  },

  pendingCount () {
    return ApiService.get('api/application-windows/pending-count')
  },

  show (uuid) {
    return ApiService.get(`api/application-windows/${uuid}`)
  },

  update (uuid, data) {
    return ApiService.putWithoutLoading(`api/application-windows/${uuid}`, data)
  },

  archive (uuid) {
    return ApiService.patchWithoutLoading(`api/application-windows/${uuid}/archive`)
  },

  restore (uuid) {
    return ApiService.patchWithoutLoading(`api/application-windows/${uuid}/restore`)
  },

  delete (uuid, data) {
    return ApiService.deleteWithoutLoading(`api/application-windows/${uuid}`, data)
  },

  store (data) {
    return ApiService.post('api/application-windows', data)
  },

  teamApplications (uuid, params) {
    return ApiService.get(`api/application-windows/${uuid}/team-applications`, {
      params
    })
  },

  teamApplication (uuid, teamApplicationUuid) {
    return ApiService.get(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}`)
  },

  createTeamFromTeamApplication (uuid, teamApplicationUuid, data) {
    return ApiService.postWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/create-team`, data)
  },

  applyTeamApplicationToTeam (uuid, teamApplicationUuid, data) {
    return ApiService.postWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/apply-to-team`, data)
  },

  updateTeamApplicationStatus (uuid, teamApplicationUuid, status, reason = null) {
    return ApiService.patchWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/update-status`, { status, reason })
  },

  updateTeamApplicationCategory (uuid, teamApplicationUuid, category) {
    return ApiService.patchWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/update-category`, { category })
  },

  upsertTeamApplicationPlayer (uuid, teamApplicationUuid, data) {
    return ApiService.putWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/players/upsert`, data)
  },

  deleteTeamApplicationPlayer (uuid, teamApplicationUuid, teamApplicationPlayerId, data) {
    return ApiService.deleteWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/players/${teamApplicationPlayerId}`, data)
  },

  upsertTeamApplicationCoach (uuid, teamApplicationUuid, data) {
    return ApiService.putWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/coaches/upsert`, data)
  },

  deleteTeamApplicationCoach (uuid, teamApplicationUuid, teamApplicationCoachId, data) {
    return ApiService.deleteWithoutLoading(`api/application-windows/${uuid}/team-applications/${teamApplicationUuid}/coaches/${teamApplicationCoachId}`, data)
  },

  customFields (uuid) {
    return ApiService.get(`api/application-windows/${uuid}/custom-fields`)
  },

  storeCustomField (uuid, data) {
    return ApiService.post(`api/application-windows/${uuid}/custom-fields`, data)
  },

  updateCustomField (uuid, customFieldUuid, data) {
    return ApiService.put(`api/application-windows/${uuid}/custom-fields/${customFieldUuid}`, data)
  },

  deleteCustomField (uuid, customFieldUuid) {
    return ApiService.delete(`api/application-windows/${uuid}/custom-fields/${customFieldUuid}`)
  },

  reorderCustomFields (uuid, uuids) {
    return ApiService.patch(`api/application-windows/${uuid}/custom-fields/reorder`, { uuids })
  }
}

export default ApplicationWindowService
